import React from 'react'
import type {ContentSpacerItem} from 'src/api/types'

type Props = {
  item: ContentSpacerItem
}

/** Вертикальный отступ внутри content-секции (item type: 'spacer'). */
export const Spacer: React.FC<Props> = ({item}) => <div style={{height: item.height ?? 0}} />
